import {Outlet} from 'react-router-dom'
import './SimpleLayout.css';

const SimpleLayout = () => {
    return (
      <div className="simple-layout">
        <Outlet />
      </div>
    );
  };
  
  export { SimpleLayout };
  